var React = require('react');

function Upload (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"16","cy":"16","r":"16","fill":"#fff","key":0}),React.createElement("g",{"transform":"translate(-877 -292)","key":1},[React.createElement("rect",{"width":"22","height":"22","transform":"translate(882 297)","fill":"none","key":0}),React.createElement("g",{"transform":"translate(880.75 295.636)","key":1},[React.createElement("path",{"d":"M17,7.363l-5-5-5,5L8.063,8.423,11.25,5.236V16.75h1.5V5.236l3.188,3.188Z","key":0}),React.createElement("path",{"d":"M4.75,20.25v-5H3.25v6.5h17.5v-6.5h-1.5v5Z","key":1})])])]);
}

Upload.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = Upload;

Upload.default = Upload;
